import React from 'react';
import { BaseTimelineItemFormLayout } from 'framework/ui/timeline';
import useProjectNotesService from '../useProjectNotesService';
import { CreateForm, FormFieldsData } from 'framework/form';
import ProjectCloseoutForm from './ProjectCloseoutForm';

interface ProjectCloseoutFormProps {
  projectId: string;
  onCancel: () => void;
  submitFormFunc?: (values: FormFieldsData) => Promise<object | void>;
  afterSubmit?: { execute?: (data: any) => void };
  messageContext?: string;
}

const CreateCloseout = ({ projectId, onCancel, submitFormFunc, ...props }: ProjectCloseoutFormProps) => {
  const { createCloseout, getCloseoutValidationSchema } = useProjectNotesService();

  const defaultSubmitFormFunc = (values: FormFieldsData) => createCloseout(projectId, values);

  return (
    <CreateForm
      submitFormFunc={submitFormFunc || defaultSubmitFormFunc}
      getValidationSchemaFunc={getCloseoutValidationSchema}
      {...props}
    >
      <BaseTimelineItemFormLayout isCreateForm onCancel={onCancel}>
        <ProjectCloseoutForm />
      </BaseTimelineItemFormLayout>
    </CreateForm>
  );
};

export default CreateCloseout;
